// extracted by mini-css-extract-plugin
export default {"header":"App_header__NiW2c","border":"App_border__m5Sf8","wave":"App_wave__eH8p5"};